import React from 'react';
import { Link } from 'react-router-dom';
import { buildBusinessPath } from '../utils/directoryUrls';
import './ListingList.css';

export default function ListingList({
    listings,
    categoryName,
    cityName,
    stateName,
    stateSlug,
    citySlug,
    categorySlug,
    page,
    totalPages,
    onNextPage,
    onPrevPage
}) {

    const ensureHttp = (url) => {
        if (!url) return '';
        const u = String(url).trim();
        return /^https?:\/\//i.test(u) ? u : `https://${u}`;
    };

    return (
        <section className="listing-section">
            <div className="listing-container">
                <div className="listing-header">
                    <h2 className="listing-title">{categoryName} in {cityName}</h2>
                    <p className="listing-subtitle">Browse top-rated businesses and services</p>
                </div>

                <div className="listing-grid">
                    {listings?.map((item) => {
                        const businessPath = item.slug
                            ? buildBusinessPath({
                                stateSlug,
                                citySlug,
                                categorySlug: item.category_slug || item.categorySlug || categorySlug,
                                slug: item.slug
                            })
                            : '';
                        const websiteUrl = !businessPath ? ensureHttp(item.website) : '';
                        return (
                            <div key={item.id} className="listing-card">
                                <div className="listing-content">
                                    <div className="listing-header-row">
                                        {businessPath ? (
                                            <Link to={businessPath} className="listing-name">
                                                {item.title}
                                            </Link>
                                        ) : websiteUrl ? (
                                            <a href={websiteUrl} target="_blank" rel="noreferrer" className="listing-name">
                                                {item.title}
                                            </a>
                                        ) : (
                                            <span className="listing-name">{item.title}</span>
                                        )}
                                    </div>

                                    <div className="listing-meta">
                                        {item.address && (
                                            <div className="meta-item">
                                                <svg className="meta-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                                                </svg>
                                                <span>{item.address}</span>
                                            </div>
                                        )}
                                        {item.phone && (
                                            <div className="meta-item">
                                                <svg className="meta-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                                                </svg>
                                                <span>{item.phone}</span>
                                            </div>
                                        )}
                                    </div>

                                    <div className="listing-actions">
                                        {businessPath ? (
                                            <Link to={businessPath} className="action-btn btn-primary">
                                                Visit Profile
                                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                                                    <polyline points="15 3 21 3 21 9" />
                                                    <line x1="10" y1="14" x2="21" y2="3" />
                                                </svg>
                                            </Link>
                                        ) : websiteUrl ? (
                                            <a href={websiteUrl} target="_blank" rel="noreferrer" className="action-btn btn-primary">
                                                Visit Profile
                                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                                                    <polyline points="15 3 21 3 21 9" />
                                                    <line x1="10" y1="14" x2="21" y2="3" />
                                                </svg>
                                            </a>
                                        ) : null}

                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>

                <div className="pagination">
                    <button className="page-btn" onClick={onPrevPage} disabled={page <= 1}>Previous</button>
                    <span className="page-info">Page {page}</span>
                    <button className="page-btn" onClick={onNextPage} disabled={page >= totalPages}>Next</button>
                </div>

                <div className="breadcrumbs">
                    <Link to="/">India</Link> / <Link to={`/in/${stateSlug}`}>{stateName}</Link> / <Link to={`/in/${stateSlug}/${citySlug}`}>{cityName}</Link> / <span>{categoryName}</span>
                </div>
            </div>
        </section>
    );
}
